var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "manage-bookings-item grid-cols-[repeat(14,minmax(0,1fr))] gap-2 lg:grid"
      },
      [
        _c("img", {
          staticClass: "manage-bookings-item__image col-span-1 mb-4 lg:my-auto",
          attrs: { src: _vm.booking.property.listingMainPhoto, alt: "image" }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-span-4 grid grid-cols-12 mb-1 lg:my-auto" },
          [
            _c("div", { staticClass: "col-span-9" }, [
              _c("h4", { staticClass: "font-semibold" }, [
                _vm._v(_vm._s(_vm.booking.property.listingAddress))
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.booking.property.postcode) +
                    ", " +
                    _vm._s(_vm.booking.property.location)
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "col-span-3 text-right lg:text-left my-auto" },
              [
                _vm._v(
                  "€ " + _vm._s((_vm.booking.price + "").replace(".", ","))
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "manage-bookings-item__row col-span-2 lg:justify-start"
          },
          [
            _c(
              "span",
              { staticClass: "manage-bookings-item__row-definition" },
              [
                _vm._v(
                  _vm._s(
                    _vm.locales &&
                      _vm.locales["property-bookings"] &&
                      _vm.locales["property-bookings"].candidates
                  )
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "manage-bookings-item__candidates" }, [
              _vm.booking.user &&
              _vm.booking.user.subscription &&
              _vm.booking.user.subscription.tenants &&
              _vm.booking.user.subscription.tenants.length > 1
                ? _c(
                    "div",
                    { ref: "candidatesPopupWrapper", staticClass: "relative" },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "manage-bookings-item__candidates-button hidden lg:block",
                          class: { active: _vm.isCandidatesPopupOpen },
                          on: { click: _vm.toggleCandidatesPopup }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.booking.user.subscription.tenants.length +
                                " candidates"
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass:
                            "manage-bookings-item__candidates-button block lg:hidden",
                          attrs: {
                            "data-feature": "open-modal",
                            "data-target": "candidates-modal" + _vm.booking.id
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.booking.user.subscription.tenants.length +
                                  " candidates"
                              ) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isCandidatesPopupOpen
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "manage-bookings-item__candidates-popup"
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "font-bold mb-2 block" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.booking.user.subscription.tenants
                                        .length +
                                        " candidates" +
                                        ":"
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "ul",
                                _vm._l(
                                  _vm.booking.user.subscription.tenants,
                                  function(candidate) {
                                    return _c(
                                      "li",
                                      {
                                        staticClass:
                                          "manage-bookings-item__candidates-popup-value"
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              candidate.fullNameWithTitle
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                : _c("span", [
                    _vm._v(_vm._s(_vm.booking.user.fullNameWithTitle))
                  ])
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "manage-bookings-item__row col-span-1" }, [
          _c("span", { staticClass: "manage-bookings-item__row-definition" }, [
            _vm._v(
              _vm._s(
                _vm.locales &&
                  _vm.locales["peoperty-bookings"] &&
                  _vm.locales["peoperty-bookings"].period
              )
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _c("span", [
              _vm._v(_vm._s(_vm._f("formatDate2")(_vm.booking.start_date)))
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm._f("formatDate2")(_vm.booking.end_date)))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "manage-bookings-item__row col-span-2" }, [
          _c("span", { staticClass: "manage-bookings-item__row-definition" }, [
            _vm._v(
              _vm._s(
                _vm.locales &&
                  _vm.locales["peoperty-bookings"] &&
                  _vm.locales["peoperty-bookings"].status
              )
            )
          ]),
          _vm._v(" "),
          _c("div", {}, [
            _vm.booking.is_approved === null || _vm.booking.is_approved == 0
              ? _c(
                  "span",
                  { staticClass: "status-marker status-marker--orange" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.locales &&
                            _vm.locales.common &&
                            _vm.locales.common.requested
                        ) +
                        "\n        "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.booking.is_approved == 1 &&
            new Date(_vm.booking.start_date) > new Date()
              ? _c(
                  "span",
                  { staticClass: "status-marker status-marker--green" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.locales &&
                            _vm.locales.common &&
                            _vm.locales.common.upcoming
                        ) +
                        "\n        "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.booking.is_approved == 1 &&
            new Date(_vm.booking.end_date) < new Date()
              ? _c(
                  "span",
                  { staticClass: "status-marker status-marker--gray" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.locales &&
                            _vm.locales.common &&
                            _vm.locales.common.past
                        ) +
                        "\n        "
                    )
                  ]
                )
              : _vm.booking.is_approved == -1
              ? _c(
                  "span",
                  { staticClass: "status-marker status-marker--gray-disabled" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.locales &&
                            _vm.locales.common &&
                            _vm.locales.common.rejected
                        ) +
                        "\n        "
                    )
                  ]
                )
              : _vm.booking.is_approved == -2
              ? _c(
                  "span",
                  { staticClass: "status-marker status-marker--gray-disabled" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.locales &&
                            _vm.locales.common &&
                            _vm.locales.common.cancelled
                        ) +
                        "\n        "
                    )
                  ]
                )
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "manage-bookings-item__contacts-block col-span-2" },
          [
            _c("div", { ref: "popupWrapperMail", staticClass: "relative" }, [
              _c(
                "button",
                {
                  staticClass: "hidden lg:block",
                  on: { click: _vm.toggleMailPopup }
                },
                [
                  _c("span", {
                    staticClass: "icon-mail icon-orange",
                    class: { active: _vm.isMailPopupOpen }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "block lg:hidden",
                  attrs: {
                    "data-feature": "open-modal",
                    "data-target": "email-modal" + _vm.booking.id
                  }
                },
                [_c("span", { staticClass: "icon-mail icon-orange" })]
              ),
              _vm._v(" "),
              _vm.isMailPopupOpen
                ? _c(
                    "ul",
                    { staticClass: "manage-bookings-item__contacts-popup" },
                    [
                      _vm.booking.user &&
                      _vm.booking.user.subscription &&
                      _vm.booking.user.subscription.tenants &&
                      _vm.booking.user.subscription.tenants.length > 1
                        ? _vm._l(
                            _vm.booking.user.subscription.tenants,
                            function(candidate, i) {
                              return _c(
                                "li",
                                {
                                  key: i,
                                  staticClass:
                                    "manage-bookings-item__contacts-popup-item",
                                  attrs: { "data-copied": "wrapper" }
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "manage-bookings-item__contacts-popup-value",
                                      attrs: { "data-copied": "value" }
                                    },
                                    [_vm._v(_vm._s(candidate.email))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "flex gap-2 items-center" },
                                    [
                                      _c("span", {
                                        staticClass: "icon-copy icon-orange",
                                        on: { click: _vm.copyToClipboard }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "mailto:" + candidate.email
                                          }
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "icon-send icon-orange"
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            }
                          )
                        : [
                            _c(
                              "li",
                              {
                                staticClass:
                                  "manage-bookings-item__contacts-popup-item",
                                attrs: { "data-copied": "wrapper" }
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "manage-bookings-item__contacts-popup-value",
                                    attrs: { "data-copied": "value" }
                                  },
                                  [_vm._v(_vm._s(_vm.booking.user.email))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex gap-2 items-center" },
                                  [
                                    _c("span", {
                                      staticClass: "icon-copy icon-orange",
                                      on: { click: _vm.copyToClipboard }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            "mailto:" + _vm.booking.user.email
                                        }
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "icon-send icon-orange"
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                    ],
                    2
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { ref: "popupWrapperPhone", staticClass: "relative" }, [
              _c(
                "button",
                {
                  staticClass: "hidden lg:block",
                  on: { click: _vm.togglePhonePopup }
                },
                [
                  _c("span", {
                    staticClass: "icon-phone icon-orange",
                    class: { active: _vm.isPhonePopupOpen }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "block lg:hidden",
                  attrs: {
                    "data-feature": "open-modal",
                    "data-target": "phone-modal" + _vm.booking.id
                  }
                },
                [_c("span", { staticClass: "icon-phone icon-orange" })]
              ),
              _vm._v(" "),
              _vm.isPhonePopupOpen
                ? _c(
                    "ul",
                    { staticClass: "manage-bookings-item__contacts-popup" },
                    [
                      _vm.booking.user &&
                      _vm.booking.user.subscription &&
                      _vm.booking.user.subscription.tenants &&
                      _vm.booking.user.subscription.tenants.length > 1
                        ? _vm._l(
                            _vm.booking.user.subscription.tenants,
                            function(candidate, i) {
                              return _c(
                                "li",
                                {
                                  key: i,
                                  staticClass:
                                    "manage-bookings-item__contacts-popup-item",
                                  attrs: { "data-copied": "wrapper" }
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "manage-bookings-item__contacts-popup-value",
                                      attrs: { "data-copied": "value" }
                                    },
                                    [_vm._v(_vm._s(candidate.phone_number))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "flex gap-2 items-center" },
                                    [
                                      _c("span", {
                                        staticClass: "icon-copy icon-orange",
                                        on: { click: _vm.copyToClipboard }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href:
                                              "tel:" + candidate.phone_number
                                          }
                                        },
                                        [
                                          _c("span", {
                                            staticClass:
                                              "icon-phone icon-orange"
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            }
                          )
                        : [
                            _c(
                              "li",
                              {
                                staticClass:
                                  "manage-bookings-item__contacts-popup-item",
                                attrs: { "data-copied": "wrapper" }
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "manage-bookings-item__contacts-popup-value",
                                    attrs: { "data-copied": "value" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.booking.user.phone_number)
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex gap-2 items-center" },
                                  [
                                    _c("span", {
                                      staticClass: "icon-copy icon-orange",
                                      on: { click: _vm.copyToClipboard }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            "tel:" +
                                            _vm.booking.user.phone_number
                                        }
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "icon-phone icon-orange"
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                    ],
                    2
                  )
                : _vm._e()
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "manage-bookings-item__buttons-block col-span-2" },
          [
            _vm.booking.is_approved === null || _vm.booking.is_approved == 0
              ? _c(
                  "button",
                  {
                    staticClass:
                      "theme-btn theme-btn--small theme-btn--destructive",
                    on: {
                      click: function($event) {
                        return _vm.deleteBooking(_vm.booking.id)
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.locales &&
                          _vm.locales["property-bookings"] &&
                          _vm.locales["property-bookings"].reject
                      )
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.booking.is_approved === null || _vm.booking.is_approved == 0
              ? _c(
                  "button",
                  {
                    staticClass: "theme-btn theme-btn--small theme-btn--theme",
                    on: {
                      click: function($event) {
                        return _vm.acceptBooking(_vm.booking.id)
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.locales &&
                          _vm.locales["property-bookings"] &&
                          _vm.locales["property-bookings"].approve
                      )
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "theme-btn theme-btn--small theme-btn--theme",
                attrs: {
                  href:
                    (_vm.lang != "nl" ? "/" + _vm.lang : "") +
                    "/bookings/details/" +
                    _vm.booking.id
                }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.locales &&
                        _vm.locales["property-bookings"] &&
                        _vm.locales["property-bookings"].view_details
                    ) +
                    "\n        "
                ),
                _c("span", { staticClass: "icon-thin-right" })
              ]
            )
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal modal--bottom",
        attrs: {
          "data-feature": "modal",
          "data-name": "candidates-modal" + _vm.booking.id
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "modal__content",
            attrs: { "data-feature": "modal-active-area" }
          },
          [
            _c(
              "button",
              {
                staticClass: "modal__close",
                attrs: {
                  "data-feature": "close-modal",
                  "data-target": "candidates-modal" + _vm.booking.id
                }
              },
              [_c("i", { staticClass: "icon-close" })]
            ),
            _vm._v(" "),
            _c("h3", { staticClass: "section-title-sm mb-4" }, [
              _vm._v(
                _vm._s(
                  _vm.locales &&
                    _vm.locales["property-bookings"] &&
                    _vm.locales["property-bookings"].candidates
                )
              )
            ]),
            _vm._v(" "),
            _c(
              "ul",
              [
                _vm.booking.user &&
                _vm.booking.user.subscription &&
                _vm.booking.user.subscription.tenants &&
                _vm.booking.user.subscription.tenants.length > 1
                  ? _vm._l(_vm.booking.user.subscription.tenants, function(
                      candidate,
                      i
                    ) {
                      return _c(
                        "li",
                        {
                          key: i,
                          staticClass: "manage-bookings-item__modal-item",
                          attrs: { "data-copied": "wrapper" }
                        },
                        [
                          _c("span", { attrs: { "data-copied": "value" } }, [
                            _vm._v(_vm._s(candidate.fullNameWithTitle))
                          ]),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "icon-copy icon-orange",
                            on: { click: _vm.copyToClipboard }
                          })
                        ]
                      )
                    })
                  : [
                      _c(
                        "li",
                        {
                          staticClass: "manage-bookings-item__modal-item",
                          attrs: { "data-copied": "wrapper" }
                        },
                        [
                          _c("span", { attrs: { "data-copied": "value" } }, [
                            _vm._v(_vm._s(_vm.booking.user.fullNameWithTitle))
                          ]),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "icon-copy icon-orange",
                            on: { click: _vm.copyToClipboard }
                          })
                        ]
                      )
                    ]
              ],
              2
            )
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal modal--bottom",
        attrs: {
          "data-feature": "modal",
          "data-name": "email-modal" + _vm.booking.id
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "modal__content",
            attrs: { "data-feature": "modal-active-area" }
          },
          [
            _c(
              "button",
              {
                staticClass: "modal__close",
                attrs: {
                  "data-feature": "close-modal",
                  "data-target": "email-modal" + _vm.booking.id
                }
              },
              [_c("i", { staticClass: "icon-close" })]
            ),
            _vm._v(" "),
            _c("h3", { staticClass: "section-title-sm mb-4" }, [
              _vm._v(
                _vm._s(
                  _vm.locales && _vm.locales.common && _vm.locales.common.email
                )
              )
            ]),
            _vm._v(" "),
            _c(
              "ul",
              [
                _vm.booking.user &&
                _vm.booking.user.subscription &&
                _vm.booking.user.subscription.tenants &&
                _vm.booking.user.subscription.tenants.length > 1
                  ? _vm._l(_vm.booking.user.subscription.tenants, function(
                      candidate,
                      i
                    ) {
                      return _c(
                        "li",
                        {
                          key: i,
                          staticClass: "manage-bookings-item__modal-item",
                          attrs: { "data-copied": "wrapper" }
                        },
                        [
                          _c("span", { attrs: { "data-copied": "value" } }, [
                            _vm._v(_vm._s(candidate.email))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex items-center gap-3" },
                            [
                              _c("span", {
                                staticClass: "icon-copy icon-orange",
                                on: { click: _vm.copyToClipboard }
                              }),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  attrs: { href: "mailto:" + candidate.email }
                                },
                                [
                                  _c("span", {
                                    staticClass: "icon-send icon-orange"
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    })
                  : [
                      _c(
                        "li",
                        {
                          staticClass: "manage-bookings-item__modal-item",
                          attrs: { "data-copied": "wrapper" }
                        },
                        [
                          _c("span", { attrs: { "data-copied": "value" } }, [
                            _vm._v(_vm._s(_vm.booking.user.email))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex items-center gap-3" },
                            [
                              _c("span", {
                                staticClass: "icon-copy icon-orange",
                                on: { click: _vm.copyToClipboard }
                              }),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "mailto:" + _vm.booking.user.email
                                  }
                                },
                                [
                                  _c("span", {
                                    staticClass: "icon-send icon-orange"
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
              ],
              2
            )
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal modal--bottom",
        attrs: {
          "data-feature": "modal",
          "data-name": "phone-modal" + _vm.booking.id
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "modal__content",
            attrs: { "data-feature": "modal-active-area" }
          },
          [
            _c(
              "button",
              {
                staticClass: "modal__close",
                attrs: {
                  "data-feature": "close-modal",
                  "data-target": "phone-modal" + _vm.booking.id
                }
              },
              [_c("i", { staticClass: "icon-close" })]
            ),
            _vm._v(" "),
            _c("h3", { staticClass: "section-title-sm mb-4" }, [
              _vm._v(
                _vm._s(
                  _vm.locales && _vm.locales.common && _vm.locales.common.phone
                )
              )
            ]),
            _vm._v(" "),
            _c(
              "ul",
              [
                _vm.booking.user &&
                _vm.booking.user.subscription &&
                _vm.booking.user.subscription.tenants &&
                _vm.booking.user.subscription.tenants.length > 1
                  ? _vm._l(_vm.booking.user.subscription.tenants, function(
                      candidate,
                      i
                    ) {
                      return _c(
                        "li",
                        {
                          key: i,
                          staticClass: "manage-bookings-item__modal-item",
                          attrs: { "data-copied": "wrapper" }
                        },
                        [
                          _c("span", { attrs: { "data-copied": "value" } }, [
                            _vm._v(_vm._s(candidate.phone_number))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex items-center gap-3" },
                            [
                              _c("span", {
                                staticClass: "icon-copy icon-orange",
                                on: { click: _vm.copyToClipboard }
                              }),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "tel:" + candidate.phone_number
                                  }
                                },
                                [
                                  _c("span", {
                                    staticClass: "icon-phone icon-orange"
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    })
                  : [
                      _c(
                        "li",
                        {
                          staticClass: "manage-bookings-item__modal-item",
                          attrs: { "data-copied": "wrapper" }
                        },
                        [
                          _c("span", { attrs: { "data-copied": "value" } }, [
                            _vm._v(_vm._s(_vm.booking.user.phone_number))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex items-center gap-3" },
                            [
                              _c("span", {
                                staticClass: "icon-copy icon-orange",
                                on: { click: _vm.copyToClipboard }
                              }),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "tel:" + _vm.booking.user.phone_number
                                  }
                                },
                                [
                                  _c("span", {
                                    staticClass: "icon-phone icon-orange"
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
              ],
              2
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08f3a81d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08f3a81d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/ManageBookingsItem.vue
// module id = 718
// module chunks = 1